/**
 * Retrieves all the mega menu panels from the document.
 *
 * @return {NodeListOf<Element>} The list of mega menu panels.
 */
function getMegaMenuPanels() {
  const mega_menu_panels = document.querySelectorAll(".mega-menu");
  return mega_menu_panels;
}

/**
 * Toggles the visibility of mega menu panels based on mouseover and mouseleave events on menu items.
 *
 * @param None
 * @return None
 */
function toggleMegaMenuPanels() {
  const mega_menu_panels = getMegaMenuPanels();

  const megaMenuItems = document.querySelectorAll("#menu-primary li");
  megaMenuItems.forEach((menuItem) => {
    menuItem.addEventListener("mouseover", function (e) {
      if (menuItem.classList.contains("is-mega-menu-item")) {
        mega_menu_panels.forEach((megaMenu) => {
          megaMenu.classList.remove("active");
        });
        const panel = document.querySelector(
          ".mega-menu[data-mega-menu-reference=" +
            menuItem.getAttribute("id") +
            "]"
        );
        panel.classList.add("active");
      } else {
        mega_menu_panels.forEach((mega_menu_panel) => {
          mega_menu_panel.classList.remove("active");
        });
      }
    });
  });

  //Handle global menu mouseleave to hide mega menu panels unless the next target is a mega menu panel
  const headerBottom = document.querySelector(".header-bottom");
  headerBottom.addEventListener("mouseleave", function (e) {
    if (!e.relatedTarget) return;
    if (e.relatedTarget.classList.contains("mega-menu")) return;
    mega_menu_panels.forEach((mega_menu_panel) => {
      mega_menu_panel.classList.remove("active");
    });
  });

  mega_menu_panels.forEach((megaMenu) => {
    megaMenu.addEventListener("mouseleave", function (e) {
      e.target.classList.remove("active");
    });
  });
}

/**
 * Positions the mega menu panels below the header menu.
 *
 * @param None
 * @return None
 */
function sizeMegaMenuPanels() {
  const mega_menu_panels = getMegaMenuPanels();
  mega_menu_panels.forEach((mega_menu_panel) => {
    var currentViewPortHeight = window.innerHeight;
    var headerHeight = document.querySelector("#masthead").offsetHeight;
    var remainingHeight = currentViewPortHeight - headerHeight;
    if (remainingHeight < 800) {
      mega_menu_panel.setAttribute("style", `max-height:${remainingHeight}px;`);
    }
  });
}

/**
 * Toggles the visibility of the mega menu right column elements when the corresponding buttons are hovered over.
 *
 * @param {None}
 * @return {None}
 */
function toggleMegaMenuRightCol() {
  const rightColButtons = document.querySelectorAll("[data-right-col-target]");
  rightColButtons.forEach((rightColButton) => {
    const target = document.querySelector(
      "#" + rightColButton.getAttribute("data-right-col-target")
    );
    rightColButton.addEventListener("mouseover", function () {
      const otherRightColElements = document.querySelectorAll(
        ".right-col-inner:not(#" +
          rightColButton.getAttribute("data-right-col-target") +
          ")"
      );
      target.classList.remove("hide-information");
      otherRightColElements.forEach((rightColElement) => {
        rightColElement.classList.add("hide-information");
      });
    });
  });
}

export default function activateMenu() {
  if (document.querySelector(".mega-menu")) {
    sizeMegaMenuPanels();
    toggleMegaMenuPanels();
    toggleMegaMenuRightCol();
  }

  window.addEventListener("resize", function () {
    if (document.querySelector(".mega-menu")) {
      sizeMegaMenuPanels();
    }
  });
}
